import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.resources');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-resources',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.resources/view.scss */
.materials-alias-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: var(--design-bg);
  color: var(--design-text-secondary);
  font-family: SUIT, Arial, sans-serif;
  font-size: 14px;
  font-weight: 800;
}`],
})
export class PageAdminResourcesComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.href("/admin/materials");
    }
}

export default PageAdminResourcesComponent;